import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Popconfirm, Card, Input, Select, Checkbox } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import dayjs from 'dayjs';
import axios from 'axios';
import AdminModal from "./AdminModal";
const { TextArea } = Input;
const { confirm } = Modal;
const ShareLearningModal = (props) => {
    const [more_information, set_more_information] = useState(false);
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    const [topic, setTopic] = useState([]);
    const [student, setStudent] = useState([]);
    const [check, setCheck] = useState(false);
    const [schedule_date, set_schedule_date] = useState(undefined);
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        axios
            .get('/cramSchool/api/learn_witness/type')
            .then((response) => {
                let data_tmp = [];
                response.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['learn_witness_type_id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                setTopic(data_tmp)
            })

        setCheck(false);
        // console.log(props.editcard);
        if (props.editcard['annoucement_time'] != undefined) {
            setCheck(true)
            set_schedule_date(props.editcard['annoucement_time']);
        } else {
            set_schedule_date(null);
        }
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
        } else {
            props.setEditCard({ file_id: [], file_url: [] });
            set_blog_id('');
        }
    }, [props.editcard])
    useEffect(() => {
        set_more_information(false);
        if (props.editcard['more_content'] != null || undefined || "") {
            set_more_information(true);
        }
    }, [props.editcard['more_content']])
    useEffect(() => {
        axios
            .get('/cramSchool/api/student')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['student_id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                setStudent(data_tmp)
            })
    }, [])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >學習見證</Col>
                    <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['learn_witness_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>主題類別</Col>
                    <Col span={18}>
                        <Select
                            style={{
                                width: 200,
                            }}
                            // labelInValue
                            placeholder='請選擇主題類別(必填)'
                            value={props.editcard['learn_witness_type_id']}
                            options={topic}
                            onChange={(value) => {
                                // console.log(value);
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            learn_witness_type_id: value,
                                        }
                                    )
                                })
                            }}
                        >
                        </Select>
                    </Col>
                    <Col span={6}>標題</Col>
                    <Col span={18}>
                        <Input placeholder="請輸入文章標題" value={props.editcard['title']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        title: e.target.value,
                                    }
                                )
                            })}
                            autoComplete="off" />
                    </Col>
                    <Col span={6}>心得/內文</Col>
                    <Col span={18}>
                        <TextArea rows={4} placeholder="請輸入內文或心得" value={props.editcard['content']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={more_information} onChange={e => set_more_information(!more_information)}>更多內容</Checkbox>
                    </Col>
                    {
                        more_information ? <>
                            <JoditEditor
                                ref={editor}
                                value={props.editcard.more_content}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={value => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            more_content: value
                                        }
                                    )
                                })}
                                height={500}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </> : null
                    }
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={check} onChange={e => setCheck(!check)}>排程發佈</Checkbox>
                        {check || props.editcard['annoucement_time'] != undefined ?
                            <DatePicker
                                // value={props.editcard['annoucement_time'] != undefined ? dayjs(null) : dayjs(schedule_date, 'YYYY-MM-DD')}
                                value={schedule_date != '' && schedule_date != undefined && schedule_date != null ? dayjs(schedule_date, 'YYYY-MM-DD') : null}
                                onChange={(date, dateString) => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            annoucement_time: dateString,
                                        }
                                    )
                                })} />
                            : null
                        }
                    </Col>
                    <Col span={6}>見證學生</Col>
                    <Col span={18}>
                        <Select
                            mode="multiple"
                            style={{
                                width: 250,
                            }}
                            labelInValue
                            allowClear
                            placeholder='請選擇學習見證之學生'
                            defaultValue={props.editcard['prove_stu'] != null ? props.editcard['prove_stu'].map((value) => value.student_name) : []}
                            options={student}
                            onChange={(value) => {
                                // console.log([value.map((tmp) => tmp.label)]);
                                // console.log([value.map((tmp) => tmp.value)]);
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            prove_stu_id: value.map((tmp) => tmp.value),
                                            student_name: value.map((tmp) => tmp.label)
                                        }
                                    )
                                })
                            }}
                        >
                        </Select>
                    </Col>
                </Row>
            </AdminModal>
        </>
    )

}
export default ShareLearningModal;